import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../../../../shared/theming/material/material.module';
import { TableSummary } from '../../../../shared/models/table-summary.model';

@Component({
  selector: 'app-table-summary-widget',
  standalone: true,
  imports: [CommonModule, MaterialModule],
  templateUrl: './table-summary-widget.component.html',
  styleUrls: ['./table-summary-widget.component.scss'],
})
export class TableSummaryWidgetComponent {
  @Input({ required: true }) title = '';
  @Input() summary: TableSummary | null = null;
  @Input() isLoading = false;
  @Input() error = false;

  formatBytes(bytes: number): string {
    if (bytes === 0) return '0 Bytes';

    const units = ['Bytes', 'KB', 'MB', 'GB'];
    const unitIndex = Math.min(
      Math.floor(Math.log(bytes) / Math.log(1024)),
      units.length - 1
    );
    const value = bytes / Math.pow(1024, unitIndex);

    return `${parseFloat(value.toFixed(2))} ${units[unitIndex]}`;
  }

  formatDate(dateString: string): string {
    const date = new Date(dateString);
    return Number.isNaN(date.getTime()) ? 'Unavailable' : date.toLocaleString();
  }

  getStatusIcon(status?: string): string {
    switch (status) {
      case 'ACTIVE':
        return 'check_circle';
      case 'INACTIVE':
        return 'cancel';
      default:
        return 'help';
    }
  }

  getStatusClass(status?: string): string {
    switch (status) {
      case 'ACTIVE':
        return 'status-active';
      case 'INACTIVE':
        return 'status-inactive';
      default:
        return 'status-unknown';
    }
  }
}
